var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterMobileArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.615983 0.366227C0.850393 0.131889 1.16828 0.000244141 1.49973 0.000244141C1.83119 0.000244141 2.14907 0.131889 2.38348 0.366227L11.1335 9.11623C11.3678 9.35064 11.4995 9.66852 11.4995 9.99998C11.4995 10.3314 11.3678 10.6493 11.1335 10.8837L2.38348 19.6337C2.14773 19.8614 1.83198 19.9874 1.50423 19.9846C1.17649 19.9817 0.86297 19.8503 0.63121 19.6185C0.39945 19.3867 0.267989 19.0732 0.265141 18.7455C0.262293 18.4177 0.388286 18.102 0.615983 17.8662L8.48223 9.99998L0.615983 2.13373C0.381644 1.89932 0.25 1.58143 0.25 1.24998C0.25 0.918522 0.381644 0.600637 0.615983 0.366227Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMobileArrowRight);
export default __webpack_public_path__ + "static/media/CenterMobile-arrowRight.9d247c317d4ee3137b55fa2c5c444adb.svg";
export { ForwardRef as ReactComponent };